import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadsComponent } from './downloads.component';
import { AuthGuard } from '@app/common/auth.guard';

const routes: Routes = [
  {
    canActivate: [AuthGuard],
    path: '',
    component: DownloadsComponent,
    data: {
      breadcrumb: {
        title: 'INICIO',
        parent: 'Descargas',
        path: '/',
        children: ''
      },
      module: 'Descargas'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DownloadsRoutingModule { }
